import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  editTagTitle: {
    description: 'editTagModal.title',
    defaultMessage: 'Edit Tag',
    id: 'EZhnjk',
  },
  editTagDone: {
    description: 'editTagModal.done',
    defaultMessage: 'Done',
    id: 'So2zvN',
  },
  editTagErrorTitle: {
    description: 'editTagModal.editTagErrorTitle',
    defaultMessage: 'Edit Tag Error',
    id: 'Wyz+n6',
  },
  editTagErrorMessage: {
    description: 'editTagModal.editTagErrorMessage',
    defaultMessage: 'Tag changes could not be saved at this time. Please try again.',
    id: 'AVR+IP',
  },
});
